export enum FileType {
  JPG = "JPG",
  PNG = "PNG",
  DOC = "DOC",
  DOCX = "DOCX",
  PDF = "PDF",
  CSV = "CSV",
}

export function isImage(fileType: FileType | null) {
  return fileType !== null && (fileType === FileType.JPG || fileType === FileType.PNG);
}

export function isPDF(fileType: FileType | null) {
  return fileType !== null && fileType === FileType.PDF;
}

export function isWord(fileType: FileType | null) {
  return fileType !== null && (fileType === FileType.DOC || fileType === FileType.DOCX);
}

export function isCSV(fileType: FileType | null) {
  return fileType !== null && fileType === FileType.CSV;
}

export function getFileIcon(filetype: FileType | null) {
  switch (filetype) {
    case FileType.PDF:
      return "pi-file-pdf";
    case FileType.CSV:
      return "pi-file-excel";
    case FileType.DOC:
    case FileType.DOCX:
      return "pi-file-word";
    default:
      return "pi-file";
  }
}
